import { render, staticRenderFns } from "./PremiumInfo.vue?vue&type=template&id=92c4c23a"
import script from "./PremiumInfo.vue?vue&type=script&lang=js"
export * from "./PremiumInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports